import { Injectable } from '@angular/core';
import { HttpGeneralService } from './../../shared/http-general.service';
import { CONFIG } from './../../shared/config';
import { EmrSpecialtyImages } from './emr-specialty-images';

const emrUrl = CONFIG.baseUrls.emrSheets;

@Injectable()
export class EmrSpecialtyImagesService {

    constructor(private http: HttpGeneralService) { }

    MedicalSpeciatiesImagesSearch(entity: EmrSpecialtyImages) {
        return this.http.search(entity, `${emrUrl}/EmrSpecialtyImages`);
    }

    MedicalSpeciatiesImagesSave(entity: EmrSpecialtyImages) {
        return this.http.add(entity, `${emrUrl}/EmrSpecialtyImages`);
    }

}
